import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "rounded-lg bg-emerald-50 px-4 py-3 text-sm text-emerald-800"
}
const _hoisted_2 = { class: "text-sm text-gray-600" }
const _hoisted_3 = { class: "text-sm text-gray-600" }

import { computed } from 'vue'

import AmountField from '@/components/neue/wizard/AmountField.vue'
import HelpHint from '@/components/neue/wizard/HelpHint.vue'
import HighlightedText from '@/components/neue/wizard/HighlightedText'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { PRICING_STACKING_NOTE, pricingOptions, sectionCopy } from '@/config/membershipTierWizardSteps'
import { overrideNote, pricingExample, pricingTiersHint } from '@/helpers/membershipTierWizardSummary'


export default {
  __name: 'StepPricing',
  props: {
  example: { type: Object, default: null },
  currency: { type: String, default: 'USD' }
},
  setup(__props) {

const PRICING_ICONS = { keep: 'check', percent: 'percent', amount: 'banknote' }

const props = __props

const wizard = injectWizard()
const pricing = computed(() => wizard.data.pricing)
const options = computed(() =>
  pricingOptions(wizard.data, { customPriceCount: wizard.meta?.value?.custom_price_count ?? 0 })
)
const settingPrices = computed(() => pricing.value.mode === 'percent' || pricing.value.mode === 'amount')
const context = computed(() => ({ example: props.example, currency: props.currency }))

const exampleText = computed(() => pricingExample(wizard.data, context.value))
const overrideText = computed(() => overrideNote(wizard.data))
const tiersHint = computed(() => pricingTiersHint(wizard.data, context.value))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('prices', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(SelectionGroup, {
          label: _unref(sectionCopy)('prices', _unref(wizard).data).title
        }, {
          default: _withCtx(({ groupName }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
              return (_openBlock(), _createBlock(SelectionCard, {
                key: option.value,
                name: groupName,
                icon: PRICING_ICONS[option.value],
                title: option.title,
                subtitle: option.subtitle,
                selected: pricing.value.mode === option.value,
                onSelect: $event => (pricing.value.mode = option.value)
              }, null, 8, ["name", "icon", "title", "subtitle", "selected", "onSelect"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 16),
    (settingPrices.value)
      ? (_openBlock(), _createBlock(WizardSection, _normalizeProps(_mergeProps({ key: 0 }, _unref(sectionCopy)(pricing.value.mode, _unref(wizard).data))), {
          default: _withCtx(() => [
            (pricing.value.mode === 'percent')
              ? (_openBlock(), _createBlock(AmountField, {
                  key: 0,
                  modelValue: pricing.value.percent,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((pricing.value.percent) = $event)),
                  kind: "percent",
                  name: "Discount"
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createBlock(AmountField, {
                  key: 1,
                  modelValue: pricing.value.amountCents,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((pricing.value.amountCents) = $event)),
                  kind: "money",
                  name: "Amount off"
                }, null, 8, ["modelValue"])),
            (exampleText.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                  _createVNode(_unref(HighlightedText), { text: exampleText.value }, null, 8, ["text"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true),
    (pricing.value.mode)
      ? (_openBlock(), _createBlock(WizardSection, _normalizeProps(_mergeProps({ key: 1 }, _unref(sectionCopy)('exceptions', _unref(wizard).data))), {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, [
              _createVNode(_unref(HighlightedText), { text: overrideText.value }, null, 8, ["text"])
            ]),
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("span", null, _toDisplayString(_unref(PRICING_STACKING_NOTE)), 1),
              _createVNode(HelpHint, {
                class: "ml-1",
                label: "What are pricing tiers?",
                text: tiersHint.value
              }, null, 8, ["text"])
            ])
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true)
  ], 64))
}
}

}